import { createContext, useContext, useState } from "react";

export const AppContext = createContext();
export const AppProvider = ({ children }) => {
  const [isShowExchangeNext, setIsShowExchangeNext] = useState(false);
  const [isShowFinalPayment, setIsShowFinalPayment] = useState(false);
  const [logoURL, setLogoURL] = useState();
  const [baseURL, setBaseURL] = useState();
  const [path, setPath] = useState("/");
  const [reasonID, setReasonID] = useState();
  const [isAutoFill, setIsAutoFill] = useState(false);
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const [isInternalServerError, setIsInternalServerError] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [isLoadingPayment, setIsLoadingPayment] = useState(false);
  const [isPaymentCompleted, setIsPaymentCompleted] = useState(false);
  const [razorPayPaymentSuccess, setRazorPayPaymentSuccess] = useState(false);
  const [exchangeSearchInput, setexchangeSearchInput] = useState("")
  return (
    <AppContext.Provider
      value={{
        path,
        setPath,
        isShowExchangeNext,
        setIsShowExchangeNext,
        isShowFinalPayment,
        setIsShowFinalPayment,
        logoURL,
        setLogoURL,
        baseURL,
        setBaseURL,
        reasonID,
        setReasonID,
        isAutoFill,
        setIsAutoFill,
        isBtnDisabled,
        setIsBtnDisabled,
        isInternalServerError,
        setIsInternalServerError,
        isPageLoading,
        setIsPageLoading,
        isLoadingPayment,
        setIsLoadingPayment,
        isPaymentCompleted,
        setIsPaymentCompleted,
        razorPayPaymentSuccess,
        setRazorPayPaymentSuccess,
        exchangeSearchInput,
        setexchangeSearchInput,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
export const useAppContext = () => {
  return useContext(AppContext);
};
